//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    cssClasses: function cssClasses() {
      var classes = this.$classes().concat("layouts-flow"); // switch(this.spec.distribution) {
      //   case 'fillEqually':
      //     classes.push('layouts-horizontal--fill-equally')
      //     break
      //   case 'spaceEqually':
      //     classes.push('layouts-horizontal--space-equally')
      //     break
      // }

      return classes;
    },
    cssStyles: function cssStyles() {
      var styles = this.$styles(); // switch(this.spec.align) {
      //   case 'middle':
      //     styles['align-items'] = 'center'
      //     break
      //   case 'bottom':
      //     styles['align-items'] = 'flex-end'
      //     break
      //   default:
      //     styles['align-items'] = 'flex-start'
      // }

      return styles;
    },
    innerStyles: function innerStyles() {
      var styles = {};
      Utils.type.ifObject(this.spec.innerPadding, function (padding) {
        Utils.type.ifNumber(padding.top, function (top) {
          return styles["padding-top"] = "".concat(top, "px");
        });
        Utils.type.ifNumber(padding.bottom, function (bottom) {
          return styles["padding-bottom"] = "".concat(bottom, "px");
        });
        Utils.type.ifNumber(padding.left, function (left) {
          return styles["padding-left"] = "".concat(left, "px");
        });
        Utils.type.ifNumber(padding.right, function (right) {
          return styles["padding-right"] = "".concat(right, "px");
        });
      });
      return styles;
    }
  }
};